export default __webpack_public_path__ + "static/media/voicenote-screenshot-01.da8b540a.png";